// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__OAiXE","root":"Modal_root__qJ0KS","rootFullScreen":"Modal_rootFullScreen__9kWDQ"};